import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withModifiers as _withModifiers, withCtx as _withCtx, withDirectives as _withDirectives, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/addition/empty.png'


const _withScopeId = n => (_pushScopeId("data-v-23a2bf69"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "adt-list mt_20 mb_20 rel" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = {
  class: "flex-wrap",
  style: {"padding-right":"14px"}
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { style: {"text-indent":"-10px","padding-left":"6px"} }
const _hoisted_6 = { class: "ml_10" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" ( ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" ) ")
const _hoisted_11 = { style: {"display":"flex","align-items":"center","margin-top":"3px"} }
const _hoisted_12 = { class: "optionContent" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/icon/question.png",
  class: "optionQuestion"
}, null, -1))
const _hoisted_14 = {
  class: "optionContent",
  style: {"width":"280px"}
}
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/icon/question.png",
  class: "optionQuestion"
}, null, -1))
const _hoisted_17 = { class: "abs check" }
const _hoisted_18 = {
  key: 1,
  class: "empty"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_20 = { class: "empty-text" }
const _hoisted_21 = {
  class: "abs",
  style: {"height":"294px","top":"44px","width":"100%","opacity":"0"}
}

import { ref, computed } from 'vue'
import { t } from '@/plugins/i18n'
import ImgTooltip from '@/components/common/ImgTooltip.vue'
import { getWashingMarkList } from '@/apis/setup'
import WashingMark from '@/components/additional/WashingMark.vue'
import SvgIcon from '@/components/icons/SvgIcon.vue'
import ChangeSize from './ChangeSize.vue'
import { ClickOutside as vClickOutside, ElMessage } from 'element-plus'
import { useRtfix, isKO, useSite, useUser } from '@/store'
import adtTip from './adtTip.vue'
import SpotCheck from './SpotCheck.vue'
import { useStore } from 'vuex'
import { tCurrency } from '@/views/shopcart/country'



export default /*#__PURE__*/_defineComponent({
  props: [
  'adtMap',
  'adt',
  'isDeli',
  'isAssociate',
  'product',
  'flash',
  'needChangeSize',
  'isBackSku',
  'mustAdditionId',
  'noSpot',
  // 一口价费用
  'choiceCost',
  'isStockJp'
],
  emits: ['change'],
  setup(__props, { expose, emit }) {

const props = __props
const filterItem = (preState: boolean, item: any) => {
  // 之前的逻辑，过滤尺码附加项
  if (!preState) return preState
  // 新加的逻辑
  // 过滤掉 段ボール梱包作業 ( 0元/箱 ) 这个附加项 @云飞 备货到日本展示，并收费
  if (item.additionNameJp === '段ボール梱包作業' && useSite() === 'ja' && !props.isStockJp) {
    return false
  }
  return true
}
// isAssociate 是否关联组合内的修改附加项
// needChangeSize 是否需要尺码变更附加项 1需要 2不需要禁用 默认不展示
// 是否需要回显第三方商品sku添加到尺码变更输入框内 api同步订单和关联商品库页面

const store = useStore()


const showList = computed(() => {
  return props.adt.filter((v: any) => filterItem((props.product && props.product?.productType === 1) || (props.needChangeSize && v.additionCode === 63) || !v.userFill, v))
})

const els: any = {}



const washingVisible = ref(false)

// 特殊附加项
const washMark = () => {
  return getWashingMarkList().then((res) => {
    const data = res.data ?? []
    return data.length > 0
  })
}

const expand = ref(null)
const expandStyle = ref({})
const scrollTop = ref(0)
const toExpand = (v: any) => {
  const { offsetLeft: left, offsetTop: top } = els[v.additionId]
  expandStyle.value = {
    left: left + 'px',
    top: top - scrollTop.value + 88 + 'px'
  }
  v.extraType === 2 && (expand.value = v)
  v.spotCheckSupport === 1 && (spotCheck.value = v)
}
const change = async (v: any) => {
  if (v.additionCode === 45 && !(v.additionId in props.adtMap)) {
    ElMessage.warning({
      dangerouslyUseHTMLString: true,
      message: `<div>${t('※同じsku商品の中で1点を採寸します')}</div><div>${t('skuの全商品採寸を希望する場合はカスタマーサービまでご連絡してください')}</div>`
    })
  }
  if (!v.disabled) {
    const toState = !(v.additionId in props.adtMap)
    if (toState) {
      // 未登录不需要弹水洗标配置弹窗
      if (v.additionCode === 1 && store.state.route.curShop) {
        const hasSet = await washMark()
        if (!hasSet) {
          washingVisible.value = true
          return
        }
      }
    }
    // 购物车是否是单个商品
    const isOneProduct = props.product?.buyQuantity === 1
    if (v.extraType === 2 || (v.spotCheckSupport === 1 && !isOneProduct && !props.noSpot)) {
      // 选择抽检的弹窗当购买数量为1时默认全检，再次点击出现抽检弹窗
      toExpand(v)
      return
    }
    if (v.spotCheckSupport === 1 && (isOneProduct || props.noSpot)) {
      v.spotCheckFlag = 0
      v.spotCheckRatio = ''
    }
    emit('change', [v, toState])
    linkageAddition(toState, v)
  }
}
Object.values(props.adtMap).forEach((v: any) => {
  const linkMutexOptionList = v.linkMutexOptionList ?? []
  const linkSelectionOptionList = v.linkSelectionOptionList ?? []
  props.adt.forEach((adt: any) => {
    linkSelectionOptionList.forEach((id: any) => {
      if (adt.additionCode === id) {
        // emit('change', [adt, true])
      }
    })
    linkMutexOptionList.forEach((id: any) => {
      if (adt.additionCode === id) {
        adt.disabled = true
      }
    })
  })
})

// 展示抽检比例
const spotCheck: any = ref(null)
const changeSpot = (toState: any) => {
  emit('change', [spotCheck.value, toState])
  linkageAddition(toState, spotCheck.value)
}
// 附加项联动
const linkageAddition = (toState: any, v: any) => {
  const linkCancelOptionList = v.linkCancelOptionList ?? []
  const linkMutexOptionList = v.linkMutexOptionList ?? []
  const linkSelectionOptionList = v.linkSelectionOptionList ?? []
  if (toState) {
    // 选中，考虑联动选中，加上互斥
    props.adt.forEach((adt: any) => {
      if (adt.additionId === v.additionId) {
        // 先把选中项的置灰去除
        delete adt.disabled
      }
      linkSelectionOptionList.forEach((id: any) => {
        if (adt.additionCode === id) {
          delete adt.disabled
          emit('change', [adt, true])
          if (adt.spotCheckSupport === 1) {
            adt.spotCheckFlag = 0
            adt.spotCheckRatio = ''
          }
        }
      })
      linkMutexOptionList.forEach((id: any) => {
        if (adt.additionCode === id) {
          emit('change', [adt, false])
          adt.disabled = true
        }
      })
    })
  } else {
    // 取消选中，考虑取消联动，去除互斥选项
    props.adt.forEach((adt: any) => {
      linkCancelOptionList.forEach((id: any) => {
        if (adt.additionCode === id) {
          emit('change', [adt, false])
        }
      })
      linkMutexOptionList.forEach((id: any) => {
        if (adt.additionCode === id) {
          delete adt.disabled
        }
      })
    })
  }
}

const user = useUser()

const noMemberAdditionCode = {
  ja: ['38', '9', '64', '11', '15', '42', '23', '65'],
  ko: ['38', '9', '11', '42', '23', '86'],
  en: ['38', '9', '11', '42', '23', '25']
}
const isOnlyMember = (v: any) => user.membership?.templateLevel === 0 && (!noMemberAdditionCode[useSite()].includes(String(v.additionCode)))

const autoRemove = (v: any) => {
  const state = (v.additionId in props.adtMap)
  if (state) {
    emit('change', [v, false])
  }
  return true
}

const getCost = (v: any) => {
  if (props.choiceCost) {
    return v.costWithXR ?? v.cost
  }
  return v.cost
}
expose({
  linkageAddition
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('附加项')), 1),
    _renderSlot(_ctx.$slots, "noNeedAddition"),
    (_unref(showList)?.length)
      ? (_openBlock(), _createBlock(_component_el_scrollbar, {
          key: 0,
          height: "410px",
          onScroll: _cache[1] || (_cache[1] = ({ scrollTop: top }: any) => (scrollTop.value = top)),
          style: {"width":"calc(100% + 14px)"},
          always: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(showList), (v) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: v.additionId,
                  class: _normalizeClass(["item rel btn", {
            disabled: v.disabled,
            active: v.additionId in __props.adtMap,
            flash: __props.flash?.includes(v.additionCode),
            memberOnly: isOnlyMember(v) && autoRemove(v),
            [_unref(useSite)()]: true
          }]),
                  ref: (el) => (els[v.additionId] = el)
                }, [
                  _createVNode(adtTip, {
                    tooltip: v.additionMsg
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        onClick: ($event: any) => (change(v)),
                        class: _normalizeClass(["flex-ter", { onlyMember: isOnlyMember(v) }]),
                        style: {"height":"100%"}
                      }, [
                        (v.imageUrl)
                          ? (_openBlock(), _createBlock(ImgTooltip, {
                              key: 0,
                              src: v.imageUrl,
                              height: "300px"
                            }, null, 8, ["src"]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("span", _hoisted_6, [
                            ([215, 212].includes(v.additionId))
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  innerHTML: v.additionNameJp.replace('+', '+<br/>')
                                }, null, 8, _hoisted_7))
                              : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(v.additionNameJp), 1)),
                            _hoisted_9,
                            (v.calculateConfigId === 1)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                  _createTextVNode(_toDisplayString(getCost(v)) + _toDisplayString(_unref(tCurrency)('元', v.currencyCode)) + "/", 1),
                                  _createElementVNode("sub", null, _toDisplayString(_unref(t)("件2")), 1)
                                ], 64))
                              : (v.calculateConfigId === 3)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                    _createTextVNode(_toDisplayString(_unref(t)("商品总金额")) + " " + _toDisplayString(getCost(v)) + "% ", 1)
                                  ], 64))
                                : (v.calculateConfigId === 5)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                      _createTextVNode(_toDisplayString(getCost(v)) + _toDisplayString(_unref(tCurrency)('元', v.currencyCode)) + "/", 1),
                                      _createElementVNode("sub", null, _toDisplayString(_unref(t)("发货单")), 1)
                                    ], 64))
                                  : (v.calculateConfigId === 6)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                        _createTextVNode(_toDisplayString(getCost(v)) + _toDisplayString(_unref(tCurrency)('元', v.currencyCode)) + "/", 1),
                                        _createElementVNode("sub", null, _toDisplayString(_unref(t)("箱")), 1)
                                      ], 64))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                        _createTextVNode(_toDisplayString(getCost(v)) + _toDisplayString(_unref(tCurrency)('元', v.currencyCode)), 1)
                                      ], 64)),
                            _hoisted_10
                          ]),
                          _createElementVNode("div", _hoisted_11, [
                            _withDirectives(_createVNode(_component_router_link, {
                              to: _unref(useRtfix)('iframe', { params: { name: 'qualityrules' } }),
                              target: "_blank",
                              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                              class: "extra-type"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(SvgIcon, { name: "检品标准" }),
                                _createTextVNode(" " + _toDisplayString(_unref(t)("检品标准")), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"]), [
                              [_vShow, v.extraType === 1]
                            ])
                          ])
                        ]),
                        (v.additionCode === 45)
                          ? (_openBlock(), _createBlock(_component_el_tooltip, {
                              key: 1,
                              effect: "light"
                            }, {
                              content: _withCtx(() => [
                                _createElementVNode("div", _hoisted_12, [
                                  _createElementVNode("div", null, _toDisplayString(_unref(t)('※同じsku商品の中で1点を採寸します')), 1),
                                  _createElementVNode("div", null, _toDisplayString(_unref(t)('skuの全商品採寸を希望する場合はカスタマーサービまでご連絡してください')), 1)
                                ])
                              ]),
                              default: _withCtx(() => [
                                _hoisted_13
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (v.additionCode === 67)
                          ? (_openBlock(), _createBlock(_component_el_tooltip, {
                              key: 2,
                              effect: "light"
                            }, {
                              content: _withCtx(() => [
                                _createElementVNode("div", _hoisted_14, [
                                  _createElementVNode("div", null, _toDisplayString(_unref(t)('ご注意ください：')), 1),
                                  _createElementVNode("div", {
                                    innerHTML: _unref(t)('新商品確認サービスでは、サンプルの撮影と採寸を行います。')
                                  }, null, 8, _hoisted_15),
                                  _createElementVNode("div", null, _toDisplayString(_unref(t)('同じSKUで複数の商品をご購入の場合でも、確認対象は一つの商品に限定されます。')), 1)
                                ])
                              ]),
                              default: _withCtx(() => [
                                _hoisted_16
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _withDirectives(_createElementVNode("span", _hoisted_17, [
                          _createVNode(SvgIcon, { name: "打勾" })
                        ], 512), [
                          [_vShow, v.additionId in __props.adtMap]
                        ])
                      ], 10, _hoisted_4)
                    ]),
                    _: 2
                  }, 1032, ["tooltip"])
                ], 2))
              }), 128))
            ])
          ]),
          _: 1
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(t)('データなし')), 1)
        ])),
    _withDirectives(_createElementVNode("div", _hoisted_21, null, 512), [
      [_vShow, expand.value || spotCheck.value]
    ]),
    _createVNode(_Transition, { name: "el-zoom-in-top" }, {
      default: _withCtx(() => [
        (expand.value)
          ? _withDirectives((_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "abs",
              style: _normalizeStyle([{"z-index":"11111"}, expandStyle.value])
            }, [
              _createVNode(ChangeSize, {
                product: __props.product,
                adt: expand.value,
                onChange: _cache[2] || (_cache[2] = (toState) => { emit('change', [expand.value, toState]) }),
                onClose: _cache[3] || (_cache[3] = ($event: any) => (expand.value = null)),
                isBackSku: __props.isBackSku
              }, null, 8, ["product", "adt", "isBackSku"])
            ], 4)), [
              [_unref(vClickOutside), () => (expand.value = null)]
            ])
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "el-zoom-in-top" }, {
      default: _withCtx(() => [
        (spotCheck.value)
          ? _withDirectives((_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "abs",
              style: _normalizeStyle([{"z-index":"11111"}, expandStyle.value])
            }, [
              _createVNode(SpotCheck, {
                product: __props.product,
                adt: spotCheck.value,
                onChange: _cache[4] || (_cache[4] = (e) => changeSpot(e)),
                onClose: _cache[5] || (_cache[5] = ($event: any) => (spotCheck.value = null)),
                isBackSku: __props.isBackSku
              }, null, 8, ["product", "adt", "isBackSku"])
            ], 4)), [
              [_unref(vClickOutside), () => (spotCheck.value = null)]
            ])
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (washingVisible.value)
      ? (_openBlock(), _createBlock(WashingMark, {
          key: 2,
          onClose: _cache[6] || (_cache[6] = ($event: any) => (washingVisible.value = false)),
          first: true,
          onUpdate: _cache[7] || (_cache[7] = () => { })
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})